<template>
    <!--票券詳情(禮物盒點進來) -->
    <div class="page">
        <navigation-bar Close/>
        <div class="main pb-4">
            <div class="coupon-top">
                <img :src="couponImage">

                <!--識別圖-->
                <img v-if="isShowLogoOnList && logoImage !== ''"
                     class="identify-logo"
                     :src="logoImage">

                <el-row type="flex" justify="center" class="button-line">
                    <!--todo 開啟禮包-->
                    <el-button type="warning" v-if="offersType === ticketType.GiftPack.id && isOpenGiftPack" round @click="openGiftPackModel = true">開啟禮包</el-button>
                    <el-button type="info" v-if="offersType === ticketType.Coupon.id && isConvert" @click="showGetCouponDialog" round>我要兌換</el-button>
                    <el-button type="primary" class="donate-btn" round v-show="isGift" @click="gotoGiftTransfer"><img
                            src="@/assets/images/icon-card-trans.svg">轉贈
                    </el-button>
                </el-row>
            </div>

            <div class="container">
                <div class="coupon-body">
                    <div>
                        <span class="coupon-type" :title="typeName">{{typeName}}</span>
                    </div>
                    <h4 class="mt-2 d-flex">{{commodityName}} <span class="red ml-1">x{{count}}</span></h4>

                    <template v-if="offersType === ticketType.Coupon.id">
                        <div class="UseBranch" v-if="publishUnite !== ''">
                            <h6>發行單位</h6>
                            <div class="date">
                                {{publishUnite}}
                            </div>
                        </div>

                        <div class="UseBranch">
                            <h6>適用分店</h6>
                            <div class="branch-list" @click="gotoUsefulStoreList(couponId)">
                        <span v-for="(item, index) in storeList" :key="index">
                          {{item.name}}
                        </span>
                            </div>
                            <div class="arrow-btn" @click="gotoUsefulStoreList(couponId)"  v-show="storeList.length > 0"><i class="el-icon-arrow-right"></i></div>
                        </div>

                        <div class="UseBranch" v-if="!isCertificate">
                            <h6>生效日期</h6>
                            <div class="date">
                                {{activationText}}
                            </div>
                        </div>

                        <div class="UseBranch">
                            <h6>兌換{{isCertificate ? "場次" : "期限"}}</h6>
                            <div class="date">
                                {{isCertificate ? stageInfo.stageFormat : convertTimeText}}
                            </div>
                        </div>

                        <div class="UseBranch" v-show="isShowDateList && !isCertificate" @click="gotoDateList">
                            <h6>領取日期</h6>
                            <div class="date">
                                {{this.couponPublishDateList.createdAt}}<span class="amount">{{'    x' + this.couponPublishDateList.count}}</span>
                            </div>
                            <div class="arrow-btn"><i class="el-icon-arrow-right"></i></div>
                        </div>

                        <div class="UseBranch" v-show="count > 0" @click="gotoSerialList(id, couponId)">
                            <h6>票券序號</h6>
                            <div class="date">
                                <span class="serial-number">{{code}}</span>
                                <span class="amount">{{'    x' + count}}</span>
                            </div>
                            <div class="arrow-btn"><i class="el-icon-arrow-right"/></div>
                        </div>
                    </template>

                    <!--todo 禮包內優惠券-->
                    <div v-else-if="offersType === ticketType.GiftPack.id" class="gift-pack-detail">
                        <div v-for="(item, index) in giftPackContentList" :key="index" class="li">
                            <h6>[{{item.kindName}}] {{item.name}} {{item.amount}} 張</h6>
                            <p><i class="el-icon-time mr-1"/>本券兌換期限{{item.convertTimeText}}</p>
                        </div>
                    </div>

                </div>

                <div v-show="isShowContent(content)">
                    <h6 class="mt-3">說明</h6>
                    <p>{{content}}</p>
                </div>
                <div v-show="isShowContent(notice)">
                    <h6 class="mt-4">注意事項</h6>
                    <p v-html="notice"></p>
                </div>
            </div>
        </div>

        <el-dialog
                :visible.sync="showModel"
                :show-close="false"
                :modal="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :appendToBody="isWeb"
                custom-class="commDialog">
            <div class="container">
                <img src="../../assets/images/dialog-exchange.svg" class="icon mb-0">
                <p class="text-center">請出示本畫面給現場人員<br>輸入兌換密碼</p>
                <div class="second-password">
                    <el-input
                            v-model="password"
                            show-password
                            minlength="4"
                            maxlength="4">
                    </el-input>
                    <div class="box">
                        <span v-if="password.length >= 1"/>
                    </div>
                    <div class="box">
                        <span v-if="password.length >= 2"/>
                    </div>
                    <div class="box">
                        <span v-if="password.length >= 3"/>
                    </div>
                    <div class="box">
                        <span v-if="password.length >= 4"/>
                    </div>
                </div>

                <!--          <div slot="footer" class="dialog-footer">-->
                <!--            <el-button @click="cancel" round type="info">取消</el-button>-->
                <!--            <el-button @click="confirm" round type="primary">送出</el-button>-->
                <!--          </div>-->
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="openGiftPackModel"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :appendToBody="isWeb"
                custom-class="commDialog">
            <div class="container">
                <img src="../../assets/images/dialog-exchange.svg" class="icon">
                <div class="outer-content">請問要開啟幾包禮包</div>
                <p class="small red">打開禮包後將無法再轉贈或復原</p>
                <el-row type="flex" justify="space-between" class="w-100">
                    <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent" :reset="numberControllerIndex"/>
                </el-row>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="openGiftPackModel = false" round type="info">取消</el-button>
                    <el-button @click="openGiftPack" round type="primary">開啟</el-button>
                </div>
            </div>
        </el-dialog>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>

        <comm-dialog :value="isShowDialog" :outerContent="dialogMsg" :isCancel="isDialogCancel" :eventType="dialogEvent" :positiveLabel="positiveLabel"
                     :isIcon="isIcon" :isQrcode="isQrcode" :qrcodeSrc="qrcodeSrc" :icon="icons" :isShowTime="isShowTimes" :appendToBody="isWeb"
                     @result="onDialogResult">
            <slot>
                <el-button v-if="isQrcodeScan" @click="onClickCamera" circle class="mt-3">
                    <img src="@/assets/images/camera.svg" alt="相機" class="m-0" style="width: 30px">
                </el-button>
            </slot>
        </comm-dialog>

        <GiftPackAnimation v-if="showAnimation" :list="giftPackTicketList" :isWeb="isWeb" @close="goBack"/>

        <!--網頁轉贈用-->
        <CommDialog :value="isShowDialogWeb"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <TransferCoupon isWeb :dataTokenWeb="dataToken2" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='TransferCoupon'"/>
            <UsefulStoreList isWeb :dataTokenWeb="dataToken2" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='UsefulStoreList'"/>
            <IssueDate isWeb :dataTokenWeb="dataToken2" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='IssueDate'"/>
            <IssueSerial isWeb :dataTokenWeb="dataToken2" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='IssueSerial'"/>
        </CommDialog>
    </div>
</template>

<script>

    import * as constDefine from '@/store/constDefine';

    const goToBack = 1;

    const convertCoupon = 1;
    const scanQRCodeUse = 2;
    const openScan = 3;

    import CommDialog from '@/components/CommDialog.vue';
    import NumberController from "@/components/NumberController";
    import GiftPackAnimation from "../order/components/GiftPackAnimation"
    import * as mutationTypes from "@/store/mutationTypes";
    import router from "@/router";
    import TransferCoupon from "@/views/gift/TransferCoupon";
    import UsefulStoreList from "@/views/store/UsefulStoreList";
    import IssueDate from "@/views/gift/IssueDate";
    import IssueSerial from "@/views/gift/IssueSerial";
    import {OpenScanType} from "@/store/constDefine";

    export default {
        name: "CouponPage",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            CommDialog,
            NumberController,
            GiftPackAnimation,
            TransferCoupon,
            UsefulStoreList,
            IssueDate,
            IssueSerial,
        },
        data() {
            return {
                dataToken:this.isWeb? (this.dataTokenWeb.dataToken ?? "") : (this.$route.query.dataToken ?? "") ,
                dataObject: {},
                id: this.isWeb? parseInt(this.dataTokenWeb.id || 0) : parseInt(this.$route.query.id || 0),
                couponId: this.isWeb? parseInt(this.dataTokenWeb.couponId || 0) : parseInt(this.$route.query.couponId || 0),
                activeCategory: this.isWeb? this.dataTokenWeb.activeCategory : this.$route.query.activeCategory,
                offersType: this.isWeb? parseInt(this.dataTokenWeb.offersType || constDefine.TicketType.Coupon.id) : parseInt(this.$route.query.offersType || constDefine.TicketType.Coupon.id),
                stageId: this.isWeb ? parseInt(this.dataTokenWeb.stageId || 0): parseInt(this.$route.query.stageId || 0),
                ticketType: {...constDefine.TicketType},
                isGift: false,
                couponImage: "",    //商店圖
                commodityName: "",   //物品名稱
                content: "",   //說明
                notice: "",    //注意事項
                endAt: '',     //結束時間
                couponStart: '',
                convertEnd: '',
                storeNameList: [],
                vendorList: [],
                merchantList: [],
                shoppingAreaList: [],
                couponPublishDateList: {},
                code: '',
                appUseType: 0,
                webUseType: 0,
                isShowDialog: false,     //是否顯示領取票券用的 dialog
                dialogMsg: '',          //領取票券 dialog 的訊息
                dialogEvent: 0,         //哪個事件使用 dialog的？
                isDialogCancel: false,   //dialog是否可取消

                isLoading: false,     //是否載入中
                typeName: '',   //優惠券類別
                dialogResult: 0,
                count: parseInt(this.$route.query.count ? this.$route.query.count : 0),
                showModel: false,
                password: '',
                isIcon: true,
                icons: require('@/assets/images/dialog_ticket.svg'),
                isShowTimes: false,
                isQrcode: false,
                qrcodeSrc: '',
                publishUnite: '',
                logoImage: '',
                isShowLogoOnList: false,
                convertLimitType: 0,
                useTypeList: [],
                positiveLabel: "",
                delayRun: null,
                scanParamData: {},
                storeList: [],
                cameraResult: "",
                reserveUseTypeList: [],
                couponTypeId: 0,
                isConvert: true,
                hint: "",
                activationText: "",
                convertTimeText: "",
                openGiftPackModel: false,
                //數量增減元件
                numberControllerParams: {
                    default: 1,
                    min: 1,
                    max: 1,
                },
                showAnimation: false,
                giftPackTicketList: [],
                isShowDateList: true,
                isOpenGiftPack: false,
                giftPackContentList: [],
                contentName: "",
                numberControllerIndex: 0,
                openAmount: 1,
                stageInfo: {},
                isCertificate: false,
                //掃碼兌換成功的店家
                exchangeStore: '',
                isCordova: this.$public.isCordova(),
                fromRoute: {},
                checkUseTimer: null,
                checkUseTimerCount: 0,
                isOin: false,

                dataToken2: '',
                isTypeWeb: '',
                isShowDialogWeb: false,

            }
        },
        created() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
            } catch (e) {
                this.dataObject = {}
            }

            if(this.offersType === this.ticketType.GiftPack.id) {
                this.contentName = this.ticketType.GiftPack.name
            } else {
                this.contentName = this.ticketType.Coupon.name
            }

            this.changeIsRead();
            let scanResult = sessionStorage.getItem('cameraResult');
            if (scanResult !== null && scanResult !== '') {
              //讀取完要清除，要再取得結果就要重新掃描
              sessionStorage.setItem('cameraResult', '');

              //讀取掃描結果
              this.cameraResult = this.$store.state.scanResult;
              this.$store.commit('clrScanResult');
            }
        },
        mounted() {
            if (this.dataObject.usedType === "webGetCoupon" && this.dataObject.id > 0) {
                this.couponId = this.dataObject.id
                if (this.fromRoute.name === "Login" || this.fromRoute.name === "Registered") {
                    this.webGetCoupon()
                } else {
                    this.setupData()
                }
            } else {
                this.setupData()
            }
        },
        beforeDestroy() {
            //清除延遲執行
            clearTimeout(this.delayRun);
            clearInterval(this.checkUseTimer);
        },
        beforeRouteEnter(to, from, next) {
            next(
                vm => {
                    vm.fromRoute = from;
                }
            );
        },
        methods: {
            setupData() {
                if(this.offersType === this.ticketType.GiftPack.id) {
                    this.getMySelfGiftPackInfoById();
                } else {
                    this.callGetMySelfCouponInfoByIdApi(
                        this.id,
                        this.couponId,
                        0, 0);
                }
            },
            changeIsRead: function () {
                if (typeof this.activeCategory === 'undefined' || this.activeCategory === '') return;
                if(this.offersType === this.ticketType.GiftPack.id) {
                    this.activeCategory = this.ticketType.GiftPack.value
                }
                this.$sqlite.delete('delete from gift_read  where gift_id = ? and type = ? ', [this.couponId, this.activeCategory]);
            },
            /** dialog事件 返回 */
            // eslint-disable-next-line
            onDialogResult: function (isSure, event) {
                this.isIcon = true;
                this.isQrcode = false;
                this.isShowDialog = false;

                if (event === 0) {
                    if (this.dialogResult === goToBack) {
                        this.dialogResult = 0;
                        if (this.isCordova) {
                            this.$router.push({name: 'Gift', params: {activeCategory: 'coupon', activeTab: 'use'}});
                        } else {
                            this.id = 0 //讓setupData時重新檢查可用數量
                            this.setupData()
                        }
                    }
                } else if (isSure) {
                    if (event === convertCoupon) {
                        this.callGetCouponApi(this.id);
                    } else if (event === scanQRCodeUse) {
                        this.scanQRCodeUse(this.id);
                    } else if (event === openScan) {
                        this.onClickCamera();
                    }
                }
            },

            /** 開啓 票券轉讓頁面 */
            gotoGiftTransfer() {
                let routerName = "TransferCoupon"
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "id": this.id,
                    "couponId": this.couponId,
                    "offersType": this.offersType,
                    "isGoBack": true,
                })

                if (!this.isWeb) {
                    this.$router.push({
                        name: routerName,
                        query: {dataToken: dataToken}
                    });

                } else {
                    //單店網頁版用
                    this.dataToken2 = {dataToken: dataToken}
                    this.isTypeWeb = routerName
                    this.isShowDialogWeb = true
                }
            },

            /** 顯示兌換票券詢問 dialog */
            showGetCouponDialog() {
                this.dialogEvent = 0;
                this.isDialogCancel = false;
                this.isShowTimes = false;

                let useTypeFunc = (useType) => {
                    if (useType === 1) {
                        this.setCheckDialog(convertCoupon, '確定要兌換票券？', '確定')
                        this.icons = require('@/assets/images/dialog_ticket.svg')
                    } else if (useType === 2) {
                        this.getCouponToken()
                    } else if (useType === 4) {
                        this.onClickCamera()
                    } else if (!this.isCordova) {
                        this.getCouponToken()
                    }
                }

                if (!this.isCordova) {
                    useTypeFunc(this.webUseType)
                } else if (this.couponTypeId === 5) {
                    if (this.reserveUseTypeList.indexOf('1') !== -1) {
                        this.getCouponToken()
                    }
                } else {
                    useTypeFunc(this.appUseType)
                }
            },

            /** 兌換(使用)票券 */
            callGetCouponApi: function (id) {
                this.isLoading = true;

                this.$http.fetchWithAuthEncrypt`ConvertCoupon${{
                    userCouponId: id,
                    password: this.password,
                }}
                ${json => {
                    if (json.status) {
                        this.isShowTimes = true
                        this.dialogMsg = '兌換成功';
                        this.dialogResult = goToBack;
                        this.icons = require('@/assets/images/dialog_complete.gif')
                    } else {
                        this.dialogMsg = '兌換失敗<br>' + json.message;
                        this.icons = require('@/assets/images/dialog_question.svg')
                    }
                    this.isLoading = false;
                    this.dialogEvent = 0;
                    this.isDialogCancel = false;
                    this.isShowDialog = true;

                }}`;
            },

            /**
             * (我的票券 內頁專用) 取得票券詳情
             * @param id：此票券在個人帳號內的識別ID
             * @param couponId：此票券在已建立的所有票券中的識別ID (不知道個人帳號內的ID的話，才用這個欄位搜尋)
             * */
            callGetMySelfCouponInfoByIdApi: function (id, couponId, lng, lat) {

                let self = this;
                self.isLoading = true;
                self.hint = ''

                this.$http.fetchWithAuthEncrypt`GetMySelfCouponInfoById${{
                    'id': id,
                    'couponId': couponId,
                    'lng': lng,
                    'lat': lat,
                    'stageId': self.stageId,
                }} ${json => {
                    if(json.status) {
                      if (json.data !== null && json.data !== '') {
                          try {
                              json.data = self.$crypto.decryptObjectText(json.data)
                          } catch (e) {
                              //
                          }

                          this.id = json.data.id;
                          this.couponImage = json.data.imgUrl;
                          this.commodityName = json.data.name;
                          this.endAt = json.data.activityEnd;
                          this.couponStart = json.data.couponStart;
                          this.convertEnd = json.data.convertEnd;
                          this.content = json.data.content;
                          this.notice = json.data.contentPrecautions;

                          this.isGift = json.data.isGift;
                          this.storeNameList = json.data.storeNameList;
                          this.vendorList = json.data.vendorList;
                          this.merchantList = Object.values(json.data.merchantList).flat(2);
                          this.shoppingAreaList = Object.values(json.data.shoppingAreaList).flat(2);
                          //從消費紀錄過來的可能已經沒有可使用的資料了，所以要做些調整
                          if(self.$public.notNull(json.data.couponPublishDateList)) {
                              self.couponPublishDateList = json.data.couponPublishDateList;
                          } else {
                              self.isConvert = false
                              self.isGift = false
                              self.isShowDateList = false
                          }

                          self.count = json.data.count;
                          self.code = json.data.code;
                          self.isOin = json.data.isOin;

                          if (this.isWeb) {
                              this.emitUpdateCount(couponId, self.count)
                          }

                          this.typeName = json.data.typeName;
                          this.appUseType = json.data.appUseType;
                          this.webUseType = json.data.webUseType;
                          this.publishUnite = json.data.publishUnite;
                          this.logoImage = json.data.logoImage;
                          this.isShowLogoOnList = json.data.isShowLogoOnList;
                          this.convertLimitType = json.data.convertLimitType;
                          this.useTypeList = json.data.useTypeList;
                          this.reserveUseTypeList = json.data.reserveUseTypeList;
                          this.couponTypeId = json.data.couponTypeId;
                          this.activationText = json.data.activationText;
                          this.convertTimeText = json.data.convertTimeText;
                          this.stageInfo = json.data.stageInfo;
                          this.isCertificate = json.data.isCertificate

                          if(this.couponTypeId === 5 && this.reserveUseTypeList.indexOf('1') === -1) {
                            this.isConvert = false;
                            this.hint = '僅在預訂時使用'
                          }

                          this.storeList = []
                          this.storeNameList.forEach( item => {
                            this.storeList.push({
                              "name": item.name === "" ? item.brandName : item.brandName + "-" + item.name,
                            })
                          })
                          this.merchantList.forEach( item => {
                            this.storeList.push({
                              "name": item.merchantName === "" ? item.brandName : (item.brandName === "" ? item.merchantName : item.brandName + "-" + item.merchantName),
                            })
                          })
                          this.vendorList.forEach( item => {
                            this.storeList.push({
                              "name": item.name,
                            })
                          })
                          this.shoppingAreaList.forEach( item => {
                              this.storeList.push({
                                  "name": item.name,
                              })
                          })

                          if(this.cameraResult !== "") {
                            this.delayRun = setTimeout(() => {
                              this.onScanResult(this.cameraResult);
                            }, 500) ;
                          }

                      }
                    } else {
                        self.$public.showNotify(json.message, json.status);
                        self.isConvert = false
                        self.isGift = false
                        self.isShowDateList = false
                        if (self.dataObject.usedType === "webGetCoupon" && self.dataObject.id > 0) {
                            self.$store.commit(mutationTypes.setPublicCommDialogData, {
                                isShowDialog: true,
                                outerContent: "已使用完畢",
                                isConfirm: false,
                            });
                        } else {
                            if (!self.isWeb) {
                                self.$router.go(-1);
                            } else {
                                //單店網頁版用
                                this.emitUpdateCount(couponId, 0)
                                self.$emit('close');
                            }
                        }
                    }
                    self.isLoading = false;
                }}`;
            },
            gotoDateList() {
                let routerName = "IssueDate"
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "id": this.couponId,
                })

                if (!this.isWeb) {
                    this.$router.push({name: routerName, query: {dataToken: dataToken}})
                } else {
                    //單店網頁版用
                    this.dataToken2 = {dataToken: dataToken}
                    this.isTypeWeb = routerName
                    this.isShowDialogWeb = true
                }
            },
            /** 到 票券序號列表 */
            gotoSerialList(id, couponId) {
                let routerName = "IssueSerial"
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "id": this.couponId,
                })

                if (!this.isWeb) {
                    this.$router.push({name: routerName, params: {id: id, couponId: couponId, stageId: this.stageId}, query: {dataToken: dataToken}});
                } else {
                    //單店網頁版用
                    this.dataToken2 = {id: id, couponId: couponId, stageId: this.stageId, dataToken: dataToken}
                    this.isTypeWeb = routerName
                    this.isShowDialogWeb = true
                }
            },

            /** 到 適用店家列表 */
            gotoUsefulStoreList(id) {
                let routerName = "UsefulStoreList"
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "type": "coupon",
                    "id": id,
                })

                if (!this.isWeb) {
                    this.$router.push({name: routerName, query: {dataToken: dataToken}});
                } else {
                    //單店網頁版用
                    this.dataToken2 = {dataToken: dataToken}
                    this.isTypeWeb = routerName
                    this.isShowDialogWeb = true
                }
            },
            onClickCamera() {
                if (!this.isWeb) {
                    this.$router.push({name: `ScanCode`});
                } else {
                    this.$router.push({name: `ScanCode`, query: {openScanType: OpenScanType.WebStoreCoupon}});
                }
            },
            onScanResult: function (value) {
                if (value !== "") {
                    this.cameraResult = "";
                    let scanParamData = {}

                    try {
                        scanParamData = JSON.parse(value);
                    } catch (e) {
                        if (value.startsWith('http://', 0) || value.startsWith('https://', 0)) {
                            let scanURL = new URL(value);
                            if (scanURL.search !== "") {
                                let params = scanURL.searchParams;

                                for (let pair of params.entries()) {
                                    if (pair[0] === "dataToken") {
                                        scanParamData = this.$crypto.uriComponentToObject(pair[1])
                                    }
                                }
                            }
                        }
                    }

                    this.scanParamData = scanParamData
                    if (scanParamData.usedType === constDefine.QRCodeUsedType.GetInfo) {
                        this.checkQRCodeUse()
                    } else if (scanParamData.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                        this.checkTableOrderAddItemUse()
                    } else {
                        this.$public.showNotify("請確認QR碼用途", false);
                    }
                }
            },
            checkQRCodeUse() {
                let scanParamData = this.scanParamData
                let checkList = []
                let storeName = ""
                let dialogEvent = 0
                let dialogMsg = ""
                let positiveLabel = ""
                switch (scanParamData.type) {
                    case constDefine.MerchantType.Store:
                        checkList = this.storeNameList
                        break;
                    case constDefine.MerchantType.Vendor:
                        checkList = this.vendorList
                        break;
                    case constDefine.MerchantType.ShoppingAreaMerchantList:
                        checkList = this.merchantList
                        break;
                    case constDefine.MerchantType.ShoppingArea:
                        checkList = this.shoppingAreaList
                        break;
                    default:
                        this.$public.showNotify("查無QR碼相關資料", false);
                        return false
                }

                let status = checkList.some(item => {
                    if (item.id === scanParamData.id) {
                        switch (scanParamData.type) {
                            case constDefine.MerchantType.Store:
                                storeName = item.name === "" ? item.brandName : item.brandName + " " + item.name;
                                break;
                            case constDefine.MerchantType.Vendor:
                                storeName = item.name
                                break;
                            case constDefine.MerchantType.ShoppingAreaMerchantList:
                                storeName = item.shoppingAreaName + " " + (item.merchantName === "" ? item.brandName : (item.brandName === "" ? item.merchantName : item.brandName + " " + item.merchantName));
                                break;
                            case constDefine.MerchantType.ShoppingArea:
                                storeName = item.name
                                break;
                        }
                        return true
                    }
                })

                if (status) {
                    dialogEvent = scanQRCodeUse
                    dialogMsg = `確定使用本券<div class="text-left small mt-2"><i class="el-icon-discount"></i> ${storeName}<br><i class="el-icon-present"></i> ${this.commodityName}</div>`
                    positiveLabel = "確定"
                    this.icons = require('@/assets/images/dialog_ticket.svg')
                    this.exchangeStore = `${storeName}`
                } else {
                    dialogEvent = openScan
                    dialogMsg = "本券不適用於此店家<br>請確認店家QR碼是否正確"
                    positiveLabel = "再掃一次"
                    this.icons = require('@/assets/images/dialog_question.svg')
                }

                this.setCheckDialog(dialogEvent, dialogMsg, positiveLabel)
            },
            scanQRCodeUse() {
                this.isLoading = true;
                this.$http.fetchWithAuthEncrypt`ScanQRCodeUse${{
                    id: this.id,
                    executeObject: this.scanParamData.type,
                    executeId: this.scanParamData.id,
                }}
                ${json => {
                    if (json.status) {
                        this.isShowTimes = true
                        this.dialogMsg = '兌換成功<h4 class="green mb-2 mt-2">' + this.exchangeStore + '</h4> <h4><i class="el-icon-present"></i> ' + this.commodityName + '</h4>'
                        this.icons = require('@/assets/images/dialog_complete.gif')
                        this.dialogResult = goToBack;
                    } else {
                        this.dialogMsg = '兌換失敗<br>' + json.message;
                        this.icons = require('@/assets/images/dialog_question.svg')
                    }
                    this.isLoading = false;
                    this.positiveLabel = "關閉"
                    this.dialogEvent = 0;
                    this.isDialogCancel = false;
                    this.isShowDialog = true;
                }}`;
            },
            setCheckDialog(dialogEvent, dialogMsg, positiveLabel) {
                this.dialogEvent = dialogEvent;
                this.positiveLabel = positiveLabel
                this.dialogMsg = dialogMsg;
                this.isDialogCancel = true;
                this.isShowDialog = true;
            },
            /** 是否顯示活動說明 */
            isShowContent: function(content) {
                let result = this.$public.notNull(content) && (content !== '');
                return result;
            },
            getCouponToken() {
                this.$http.fetchWithAuthEncrypt`GetCouponToken${{
                    id: this.couponId,
                    couponId: this.id,
                }}
                ${json => {
                    this.positiveLabel = "關閉"
                    if (json.status) {
                        this.qrcodeSrc = json.data
                        this.dialogMsg = this.commodityName;
                        this.isIcon = false;
                        this.isQrcode = true;
                        this.isShowDialog = true;
                    } else {
                        this.dialogMsg = json.message;
                        this.isShowDialog = true;
                    }
                }}`;
            },
            openGiftPack(){
                this.openGiftPackModel = false
                this.useGiftPack()
            },

            getMySelfGiftPackInfoById: function () {
                let self = this;
                self.isLoading = true;

                self.$http.fetchWithAuthEncrypt`GetGiftPackInfoById${{
                    id: self.couponId,
                    executeType: "getSelfGiftPack",
                }} ${json => {
                    if(json.status) {
                        let data = json.data
                        let giftPackInfo = data.giftPackInfo
                        self.id = giftPackInfo.id;
                        self.couponImage = giftPackInfo.imgUrl;
                        self.commodityName = giftPackInfo.name;
                        self.content = giftPackInfo.content;
                        self.notice = giftPackInfo.contentPrecautions;
                        self.isGift = giftPackInfo.isGift;
                        self.typeName = giftPackInfo.typeName;
                        self.count = giftPackInfo.count;
                        self.isOpenGiftPack = giftPackInfo.isOpenGiftPack;
                        self.giftPackContentList = giftPackInfo.giftPackContentList;

                        self.numberControllerParams.default = self.openAmount;
                        self.numberControllerParams.max = giftPackInfo.count;
                        self.numberControllerIndex = self.numberControllerIndex + 1;
                    } else {
                        self.$public.showNotify(json.message, json.status);
                        if (!this.isWeb) {
                            self.$router.go(-1);
                        } else {
                            //單店網頁版用
                            self.$emit('close');
                        }
                    }
                    self.isLoading = false;
                }
                }}`;
            },
            numberControllerEvent(obj) {
                let self = this;
                let event = obj.event;

                if (event === "returnNumber") {
                    self.openAmount = obj.number
                } else if (event === "clickDisabledButton") {
                    if(obj.operate === "dec") {
                        self.positiveLabel = "關閉"
                        self.dialogMsg = '禮包不可少於 1 包';
                        self.isShowDialog = true;
                    }
                }
            },
            useGiftPack() {
                let self = this
                self.isLoading = true
                self.$http.fetchWithAuthEncrypt`UseGiftPack${{
                    id: self.couponId,
                    amount: self.openAmount,
                }}
                ${json => {
                    if(json.status) {
                        let data = json.data
                        self.giftPackTicketList = data.giftPackTicketList
                        self.showAnimation = true
                    } else {
                        self.positiveLabel = "關閉"
                        self.dialogMsg = json.message;
                        self.isShowDialog = true;
                    }
                    self.isLoading = false
                }}`;
            },
            checkTableOrderAddItemUse() {
                let self = this
                self.isLoading = true
                self.$http.fetchWithAuthEncrypt`CheckTableOrderAddItemUse${{
                    id: self.id,
                    couponId: self.couponId,
                    orderId: self.scanParamData.orderId || 0,
                    storeId: self.scanParamData.storeId || 0,
                    tableId: self.scanParamData.tableId || 0,
                }}
                ${json => {
                    if (json.status) {
                        let dataToken = json.data.urlDataToken || ''
                        this.$router.push({name: 'OrderDetail', query: {dataToken: dataToken}});
                    } else {
                        self.positiveLabel = "關閉"
                        self.dialogMsg = json.message;
                        self.isShowDialog = true;
                    }
                    self.isLoading = false
                }}`;
            },
            webGetCoupon() {
                let self = this;
                self.$http.fetchWithAuthEncrypt`GetWebCoupon${{
                    id: self.couponId
                }}${json => {
                    if (json.status) {
                        if (json.message !== '') {
                            self.$store.commit(mutationTypes.setPublicCommDialogData, {
                                isShowDialog: true,
                                outerContent: json.message,
                                icons: require('@/assets/images/dialog_ticket.svg'),
                                isResultEvent: true,
                                eventName: "isContinue",
                            });
                        } else {
                            self.setupData()
                        }
                    } else {
                        self.isConvert = false
                        self.isGift = false
                        self.isShowDateList = false

                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: json.message,
                            isConfirm: false,
                        });
                    }
                }}}`;
            },
            checkUseCoupon(time) {
                let self = this;
                self.$http.fetchWithAuthEncrypt`CheckUseCoupon${{
                    couponId: self.couponId,
                    time: time,
                }}${json => {
                    if (json.status) {
                        self.id = 0 //讓setupData時重新檢查可用數量
                        clearInterval(self.checkUseTimer);
                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: '兌換成功',
                            icons: require('@/assets/images/dialog_complete.gif'),
                            isResultEvent: true,
                            eventName: "isContinue",
                        });
                    }
                }}}`;
            },
            goBack() {
                //單店網頁版用
                this.$emit('close');
            },
            onCommDialogClose(result) {
                this.isShowDialogWeb = false;
                if(result){
                    //有轉贈成功時頁面刷新
                    window.location.reload();
                }
            },
            emitUpdateCount(couponId, count) {
                this.$emit('triggerEvent', {
                    event: 'updateCount',
                    data: {
                        couponId: couponId,
                        count: count,
                    },
                })
            },
        },
        watch: {
            '$store.state.publicCommDialogData.isShowDialog': function() {
                let routerName = this.$route.name
                if (routerName === 'CouponPage' || (routerName === 'WebStoreCoupon' && this.isWeb)) {
                    this.isShowDialog = false;
                    if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                        if (this.$store.state.publicCommDialogData.eventName === "useCoupon") {
                            this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                isResultEvent: false,
                                eventName: "",
                            });

                            this.$router.push({name: 'Gift', params: {activeCategory: 'coupon', activeTab: 'record'}});
                        } else if (this.$store.state.publicCommDialogData.eventName === "isContinue") {
                            this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                isResultEvent: false,
                                eventName: "",
                            });

                            this.setupData()

                            if (this.isWeb) {
                                this.$emit('close', true);
                            }
                        }
                    }
                }
            },
            isShowDialog() {
                if (this.isQrcode) {
                    clearInterval(this.checkUseTimer);
                    if (this.isShowDialog) {
                        let time = this.$public.dateFormat('yyyy-MM-dd hh:mm:ss')
                        this.checkUseTimerCount = 0
                        this.checkUseTimer = setInterval(() => {
                            this.checkUseTimerCount++
                            if (this.checkUseTimerCount > 60) {
                                clearInterval(this.checkUseTimer);
                                this.$store.commit(mutationTypes.setPublicCommDialogData, {
                                    isShowDialog: true,
                                    outerContent: '逾時，請重新操作',
                                });
                            } else {
                                this.checkUseCoupon(time)
                            }
                        }, 3000)
                    }
                }
            },
        },
        computed: {
            isQrcodeScan() {
                return this.isQrcode && (
                    (this.isCordova && this.appUseType === 2 && this.useTypeList.includes('1')) ||
                    (!this.isCordova && this.webUseType === 2 && this.useTypeList.includes('2')))
            },
        },
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
